import { CSSObject, InterpolationWithTheme } from "@emotion/core";
import styled from '@emotion/styled'
import { colors } from "../../../styles/colors";
import { fonts } from "../../../styles/fonts";


export const PatientDetailContainer = styled.div({
    padding: "20px 30px",
    background: colors.white,
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "0 6px 10px 0 rgba(151,196,246,.19)"
});

export const LeftWrapper = styled.div({
    display: "flex",
});

export const RightWrapper = styled.div({
    color: colors.darkGrey,
    fontFamily: fonts.mediumFont,
    fontSize: 12,
    alignSelf: "center",
    cursor: "pointer"
});

export const PatientName = styled.div({
    color: colors.black,
    fontFamily: fonts.mediumFont,
    fontSize: 20
});

export const Info = styled.span({
    color: colors.black,
    fontFamily: fonts.regularFont,
    fontSize: 14
});

export const Seperator = styled.span({
    color: colors.dullGrey,
    height: 7,
    width: 7,
    margin: "0 8px"
});


export const backIconStyle: InterpolationWithTheme<any> = {
    height: 16,
    width: 25,
    position: "relative",
    top: 10,
    marginRight: 20,
    cursor: "pointer"
};

export const iconStyle: InterpolationWithTheme<any> = {
    width: 16,
    margin: "0px 7px",
    cursor: "pointer"
};